import PropTypes from "prop-types"
import "./style.scss"

export default function BetaTag() {
  return (
    <span className="components_beta-tag">
      beta
    </span>
  )
}

BetaTag.propTypes = {
  className: PropTypes.string,
}
